import AbstractCommand from "../../../core/application/AbstractCommand";
import ConversationReflectionEndedEvent from "../../conversation-reflection/event/ConversationReflectionEndedEvent";
import ConversationReflection from "../../conversation-reflection/model/ConversationReflection";
import PlatformUserTrackingService from "./PlatformUserTrackingService";

export default class TrackPlatformReflectionEnded extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {PlatformUserTrackingService} platformUserTrackingService 
     */
    constructor(dispatcher, platformUserTrackingService) {
        super(dispatcher);

        this._platformUserTrackingService = platformUserTrackingService;
    }

    execute(evt) {
        /** @type {ConversationReflectionEndedEvent} */
        const conversationReflectionEndedEvent = evt.params.data;
        const { conversation } = conversationReflectionEndedEvent;

        this._trackReflectionEnded(conversation);
    }

    /**
     * @param {ConversationReflection} conversation 
     */
    async _trackReflectionEnded(conversation) {
        console.log(`[${TrackPlatformReflectionEnded.name}] Tracking reflection ended for reflectionId: '${conversation.id}'.`);
        await this._platformUserTrackingService.reportReflectionResult({
            reflectionId: conversation.id,
            summary: conversation.summary,
        });
    }
}
